var render = function render(_c,_vm){return _c('div',{staticClass:"autocomplete_drop_item-wrapper",class:{
    'autocomplete_drop_item__selected': _vm.props.selected
  }},[_c('div',_vm._g({staticClass:"autocomplete_drop_item-body"},_vm.listeners),[_vm._v(" "+_vm._s(_vm.props.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }